import { detectIncognitoTab } from "@utils/detectIncognitoTab";
import { getTrackerId } from "@utils/utils";
import { loadGrowthbookFeatures, getFeatureValue } from '@utils/growthBook';
import { initializeLoginSdk } from "@utils/initializeLoginSdk";
import { LoginSdkConfig } from '@enums/LoginSdkConfig';

export const ACKODRIVE_LOGIN_POP_UP = 'ackodrive-login-pop-up';

export async function handleLoginFlow(loginUrl: string, sdkConfig?: LoginSdkConfig, redirectUrl?: string) {
  const loginPopupEnabled = process?.env?.NEXT_PUBLIC_LOGIN_POPUP_ENABLED === "true";

  // Case 1: Popup not enabled → direct redirect
  if (!loginPopupEnabled) {
    window.location.href = loginUrl;
    return;
  }

  // Case 2: Detect incognito mode
  const isPrivate = await detectIncognitoTab();
  if (isPrivate) {
    window.location.href = loginUrl;
    return;
  }

  // Case 3: Load Growthbook features and evaluate popup flag
  try {
    const trackerId = getTrackerId();
    await loadGrowthbookFeatures(trackerId);

    const showLoginPopUp = getFeatureValue({ flagName: ACKODRIVE_LOGIN_POP_UP });

    if (showLoginPopUp) {
      initializeLoginSdk(loginUrl, sdkConfig, redirectUrl);
    } else {
      window.location.href = loginUrl;
    }
  } catch (error) {
    console.error("Login flow failed:", error);
    window.location.href = loginUrl;
  }
}
